module.exports = __webpack_public_path__ + "img/Weapon_83.738776f9.png";